
export enum Rank {
  Master, One, Two, Three, Four, Five, Six, Seven, Eight, Nine
}
